export default "__VITE_ASSET__9d1d5fbd__"